import * as React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

export default function CodeOption({ option, selected, shouldShowSelected, shouldShowDisabled, onClick, ...props }) {
  const disabled = shouldShowDisabled && option?.canDropOnParent === false
  const showSelected = selected && shouldShowSelected
  return (
    <li
      {...props}
      style={{
        padding: '8px 16px',
        fontSize: '14px',
        paddingLeft: `${((option.level - 1) * 24) + 6}px`,
        opacity: disabled ? 0.7 : 1,
        color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'inherit',
        borderBottom: 'none', // Remove default borderß
      }}
      onClick={onClick}
    >
      <Box
        component={DoneIcon}
        sx={{ width: shouldShowSelected ? 17 : 0, height: 17, mr: '5px' }}
        style={{
          visibility: showSelected ? 'visible' : 'hidden',
        }}
      />
      <Box
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 1,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {option.name}
      </Box>
      <Box
        component={CloseIcon}
        data-testid="CloseIcon"
        sx={{ opacity: 0.6, width: 18, height: 18, ml: 'auto' }}
        style={{
          visibility: showSelected ? 'visible' : 'hidden',
        }}
      />
    </li>
  );
}
